import './transformations.css'

const Transformation = () => {
    return (
        <>
            {/* transformations */}
            <div className="transformations" id="transformations">
                <div className="container">
                    <div className="heading-div">
                        <h2>transformations</h2>
                    </div>
                    <div id="carouselExampleControls" className="carousel slide" data-mdb-ride="carousel">
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <img src="images/1.png" className="d-block w-75 m-auto" alt="Wild Landscape" />
                            </div>
                            <div className="carousel-item">
                                <img src="images/2.png" className="d-block w-75 m-auto" alt="Wild Landscape" />
                            </div>
                            <div className="carousel-item">
                                <img src="images/3.png" className="d-block w-75 m-auto" alt="Wild Landscape" />
                            </div>
                            <div className="carousel-item">
                                <img src="images/4.png" className="d-block w-75 m-auto" alt="Wild Landscape" />
                            </div>
                            <div className="carousel-item">
                                <img src="images/5.png" className="d-block w-75 m-auto" alt="Wild Landscape" />
                            </div>
                            <div className="carousel-item">
                                <img src="images/6.png" className="d-block w-75 m-auto" alt="Wild Landscape" />
                            </div>
                            <div className="carousel-item">
                                <img src="images/7.png" className="d-block w-75 m-auto" alt="Wild Landscape" />
                            </div>
                            <div className="carousel-item">
                                <img src="images/8.png" className="d-block w-75 m-auto" alt="Wild Landscape" />
                            </div>
                            <div className="carousel-item">
                                <img src="images/9.png" className="d-block w-75 m-auto" alt="Wild Landscape" />
                            </div>
                            <div className="carousel-item">
                                <img src="images/10.png" className="d-block w-75 m-auto" alt="Wild Landscape" />
                            </div>
                            <div className="carousel-item">
                                <img src="images/11.png" className="d-block w-75 m-auto" alt="Wild Landscape" />
                            </div>
                            <div className="carousel-item">
                                <img src="images/12.png" className="d-block w-75 m-auto" alt="Wild Landscape" />
                            </div>
                            <div className="carousel-item">
                                <img src="images/13.png" className="d-block w-75 m-auto" alt="Wild Landscape" />
                            </div>
                            <div className="carousel-item">
                                <img src="images/14.png" className="d-block w-75 m-auto" alt="Wild Landscape" />
                            </div>
                            <div className="carousel-item">
                                <img src="images/15.png" className="d-block w-75 m-auto" alt="Wild Landscape" />
                            </div>
                            <div className="carousel-item">
                                <img src="images/16.png" className="d-block w-75 m-auto" alt="Wild Landscape" />
                            </div>
                            <div className="carousel-item">
                                <img src="images/17.png" className="d-block w-75 m-auto" alt="Wild Landscape" />
                            </div>
                            <div className="carousel-item">
                                <img src="images/18.png" className="d-block w-75 m-auto" alt="Wild Landscape" />
                            </div>
                            <div className="carousel-item">
                                <img src="images/19.png" className="d-block w-75 m-auto" alt="Wild Landscape" />
                            </div>
                            <div className="carousel-item">
                                <img src="images/20.png" className="d-block w-75 m-auto" alt="Wild Landscape" />
                            </div>
                            <div className="carousel-item">
                                <img src="images/21.png" className="d-block w-75 m-auto" alt="Wild Landscape" />
                            </div>
                        </div>
                        <button className="carousel-control-prev" type="button" data-mdb-target="#carouselExampleControls" data-mdb-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true" />
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-mdb-target="#carouselExampleControls" data-mdb-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true" />
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>
                </div>
            </div>
            {/* transformations */}
        </>
    );
}

export default Transformation;
